import { useQuery } from '@tanstack/react-query';

import { getFieldOptions } from '../services';
import type { FieldOptionsResponse } from '../services';
import { createStableQueryOptions } from '../utils/query-options';

export const useFieldOptions = (projectId: string) => {
  return useQuery<FieldOptionsResponse>({
    queryKey: ['field-options', projectId],
    queryFn: async () => {
      try {
        const response = await getFieldOptions(projectId);
        return response.data;
      } catch (error) {
        console.error('Failed to fetch field options');
        throw error;
      }
    },
    enabled: !!projectId,
    ...createStableQueryOptions(),
  });
};
